import { Link, useLocation } from 'react-router-dom'
import { ChevronLeft, LayoutDashboard } from 'lucide-react'

interface AdminNavHeaderProps {
  title: string
  subtitle?: string
  showBack?: boolean
  backTo?: string
}

const AdminNavHeader = ({ title, subtitle, showBack = true, backTo = '/admin/dashboard' }: AdminNavHeaderProps) => {
  const location = useLocation()
  const isDashboard = location.pathname === '/admin/dashboard'

  return (
    <div className="sticky top-0 z-10 bg-white/90 backdrop-blur-xl shadow-lg border-b border-white/20">
      <div className="safe-area-top px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 flex-1 min-w-0">
            {showBack && !isDashboard && (
              <Link
                to={backTo}
                className="p-2 -m-2 rounded-full hover:bg-gray-100/80 transition-colors flex-shrink-0"
              >
                <ChevronLeft className="w-5 h-5 text-gray-600" />
              </Link>
            )}
            <div className="flex-1 min-w-0">
              <h1 className="text-xl font-bold text-gray-900 tracking-tight truncate">{title}</h1>
              {subtitle && (
                <p className="text-xs text-gray-500 mt-0.5 truncate">{subtitle}</p>
              )}
            </div>
          </div>
          {!isDashboard && (
            <Link
              to="/admin/dashboard"
              className="p-2 -m-2 rounded-full bg-primary-50 hover:bg-primary-100 transition-colors flex-shrink-0"
              title="Ir al Dashboard"
            >
              <LayoutDashboard className="w-5 h-5 text-primary-600" />
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

export default AdminNavHeader

